import { render, staticRenderFns } from "./ParentView.vue?vue&type=template&id=1aa88d47"
import script from "./ParentView.vue?vue&type=script&lang=js"
export * from "./ParentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports